module.exports = __webpack_public_path__ + "media/images/edogawa_seat_map_202402-5c145b396ac0e36b08b957f83d5f1aac.png";